'use strict';

(function () {
  angular
    .module('specsguardApp')
    .config(libElement);

  libElement.$inject = ['$stateProvider'];

  function libElement (stateProvider) {
    stateProvider.state('lib_element', {
      url: '/lib_element',
      templateUrl: 'app-legacy/lib_element/lib_element.html',
      controller: 'LibElementCtrl as elementCtrl',
      menu: {
        context: 'textual_template',
        title: '[Textual_templates]',
        subtitle: '[Tekstuele specificaties]',
        icon: 'folder_empty'
      },
      authenticate: true,
      needRole: 7,
      resolve: {
        constants: ['Constants', function (Constants) {
          return Constants.getConstants();
        }],
        elements: ['LibElement', function (LibElement) {
          return LibElement.query({}).$promise;
        }],
        modules: ['Module', function (Module) {
          return Module.query({}).$promise;
        }],
        pveTemplates: ['PvETemplateAPI', 'BuildingTemplateAPI', function (PvETemplateAPI, BuildingTemplateAPI) {
          let pveTemplatePromise = PvETemplateAPI.query({}).$promise;
          let pveBuildingPromise = BuildingTemplateAPI.query({}).$promise;

          return Promise.all([pveTemplatePromise, pveBuildingPromise]).then(function(combinedResults) {
            return combinedResults[0].concat(combinedResults[1]);
          })
        }]
      }
    });
  }
})();
